import React from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { Form as FinalForm, Field } from 'react-final-form'
import ReactSelect from 'react-select'
import Creatable from 'react-select/creatable';
import DateTimePicker from 'react-datetime-picker'
import './DateTimePicker.css'

const val2LabelValue = arr => arr.map(val => ({ label: val, value: val }))

const kategorieZadanArr = val2LabelValue(['CALkulator', 'CALKom', 'CRM', 'Reklamacje'])

let przypomnijArr = [
    { label: 'bez przypomnienia', value: '' },
    { label: '0 minut przed', value: 0 },
    { label: '5 minut przed', value: 5 * 60 },
    { label: '15 minut przed', value: 15 * 60 },
    { label: '30 minut przed', value: 30 * 60 },
    { label: '1 godzinę przed', value: 60 * 60 },
    { label: '2 godziny przed', value: 2 * 60 * 60 },
    { label: '12 godzin przed', value: 12 * 60 * 60 },
    { label: '1 dzień przed', value: 24 * 60 * 60 },
    { label: '2 dni przed', value: 2 * 24 * 60 * 60 },
    { label: '1 tydzień przed', value: 7 * 24 * 60 * 60 },
]

let nazwaZadaniaArr = val2LabelValue(['Zadzwoń', 'Wyślj e-mail'])

const required = value => (value ? undefined : "Wymagane")


const AddTodoForm = ({ onCancel, onSubmit, kategoria, linkAddress, linkTitle }) => {
    return (
        <FinalForm
            onSubmit={onSubmit}
            initialValues={{
                kiedy: new Date(),
                przypomnienie: przypomnijArr[0],
                kategoria,
                linkAddress,
                linkTitle,
                prywatne: false,
            }}
            render={({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                    {/* Nazwa */}
                    <Form.Group as={Row}>
                        <Field name="nazwa" validate={required}>
                            {props => (
                                <>
                                    <Form.Label column sm={3}>Nazwa</Form.Label>
                                    <Col sm={9}>
                                        <Creatable
                                            options={nazwaZadaniaArr}
                                            name={props.input.name}
                                            value={props.input.value}
                                            onChange={props.input.onChange}
                                            placeholder="Wybierz lub stwórz własną."
                                            formatCreateLabel={inputValue => (`Nazwa zadania: ${inputValue}`)}
                                        />

                                        {props.meta.error && props.meta.touched && <div className="font-weight-bold text-danger">
                                            {props.meta.error}
                                        </div>}
                                    </Col>
                                </>
                            )}
                        </Field>
                    </Form.Group>
                    {/* Kategoria */}
                    {kategoria ?
                        <Field name="kategoria" component="input" type="hidden" />
                        :
                        <Form.Group as={Row}>
                            <Field name="kategoria">
                                {props => (
                                    <>
                                        <Form.Label column sm={3}>Kategoria</Form.Label>
                                        <Col sm={9}><Creatable
                                            name={props.input.name}
                                            value={props.input.value}
                                            onChange={props.input.onChange}
                                            options={kategorieZadanArr}
                                            placeholder="Kategoria zadania. Wyszukaj lub stwórz własną."
                                            formatCreateLabel={inputValue => (`Własna kategoria: ${inputValue}`)}
                                        /></Col>
                                    </>
                                )}
                            </Field>
                        </Form.Group>
                    }
                    {/* Kiedy */}
                    <Form.Group as={Row}>
                        <Field name="kiedy">
                            {props => (
                                <>
                                    <Form.Label column sm={3}>Kiedy</Form.Label>
                                    <Col sm={9}><DateTimePicker
                                        name={props.input.name}
                                        value={props.input.value}
                                        onChange={props.input.onChange}
                                        disableClock
                                        locale="pl-PL"
                                        className="form-control"
                                    /></Col>
                                </>
                            )}
                        </Field>
                    </Form.Group>
                    {/* Przypomnienie */}
                    <Form.Group as={Row}>
                        <Field name="przypomnienie">
                            {props => (
                                <>
                                    <Form.Label column sm={3}>Przypomnij</Form.Label>
                                    <Col sm={9}><ReactSelect
                                        name={props.input.name}
                                        value={props.input.value}
                                        onChange={props.input.onChange}
                                        options={przypomnijArr}
                                        placeholder="Wybierz ..."
                                        isSearchable
                                    /></Col>
                                </>
                            )}
                        </Field>
                    </Form.Group>
                    {/* Opis */}
                    <Form.Group as={Row}>
                        <Field name="opis">
                            {props => (
                                <>
                                    <Form.Label column sm={3}>Opis</Form.Label>
                                    <Col sm={9}><Form.Control as="textarea" rows={7}
                                        name={props.input.name}
                                        value={props.input.value}
                                        onChange={props.input.onChange}
                                        placeholder="Opis"
                                    /></Col>
                                </>
                            )}
                        </Field>
                    </Form.Group>
                    {/* Prywatne */}
                    <Form.Group as={Row}>
                        <Field name="prywatne" type="checkbox">
                            {props => (
                                <>
                                    <Col sm={{ span: 9, offset: 3 }}>
                                        <Form.Check
                                            type="switch"
                                            id="custom-switch"
                                            label="Prywatne"
                                            value={props.input.value}
                                            onChange={props.input.onChange}
                                        />
                                        <Form.Text className="text-muted">
                                            Zadanie będzie widoczne tylko dla Ciebie. W przeciwnym razie każdy operator z Twojego punktu handlowego zobaczy to zadanie.
                                        </Form.Text>
                                    </Col>
                                </>
                            )}
                        </Field>
                    </Form.Group>
                    {linkTitle && <Field name="linkTitle" component="input" type="hidden" />}
                    {linkAddress && <Field name="linkAddress" component="input" type="hidden" />}


                    <Form.Group as={Row}>
                        <Col>
                            <Button onClick={onCancel} className="mr-2" variant="danger">Anuluj</Button>
                            <Button onClick={handleSubmit} variant="success">Zapisz</Button>
                        </Col>

                    </Form.Group>
                    <pre>{JSON.stringify(values, 0, 2)}</pre>
                </form>
            )}
        />
    )
}

export default AddTodoForm